// advertisement
const Listpodcast = () => import('@/views/podcast')
const Formapodcast = () => import('@/views/podcast/form')
const Detailpodcast = () => import('@/views/podcast/detail')

export default {
    path: 'podcast',
    redirect: '/podcast',
    component: {
        render(c) { return c('router-view') }
    },
    meta: {
        label: 'Podcast'
    },
    children: [{
            path: '/',
            name: 'podcast',
            component: Listpodcast,
            meta: {
                auth: true,
                label: 'Podcast',
                permission: {
                    link: "podcast",
                    name: "Podcast",
                }
            }
        },
        {
            path: 'add',
            name: 'addpodcast',
            component: Formapodcast,
            meta: {
                auth: true,
                label: 'Add Podcast',
                permission: {
                    link: "podcast",
                    name: "Podcast",
                }
            }
        },
        {
            path: 'edit/:id',
            name: 'editpodcast',
            component: Formapodcast,
            meta: {
                auth: true,
                label: 'Edit Podcast',
                permission: {
                    link: "podcast",
                    name: "Podcast",
                },
            }
        },
        {
            path: ':id',
            name: 'detailpodcast',
            component: Detailpodcast,
            meta: {
                auth: true,
                label: 'Detail Podcast',
                permission: {
                    link: "podcast",
                    name: "Podcast",
                },
            }
        },
    ]
}